import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const initials = (n) => (n || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");

export function StaffPhoto({ fileId, name, size = "h-14 w-14 text-base" }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!fileId) { setUrl(""); return undefined; }
    let obj = "";
    api.get(`/staff-mgmt/files/${fileId}`, { responseType: "blob" }).then((r) => { obj = URL.createObjectURL(r.data); setUrl(obj); }).catch(() => setUrl(""));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [fileId]);
  if (url) return <img src={url} alt={name} className={`${size} rounded-full object-cover ring-2 ring-white shadow`} />;
  return <div className={`${size} rounded-full bg-gradient-to-br from-violet-500 to-purple-700 flex items-center justify-center text-white font-bold ring-2 ring-white shadow`}>{initials(name)}</div>;
}

export const STATUS_TONE = { active: "bg-emerald-100 text-emerald-800", probation: "bg-amber-100 text-amber-800", on_leave: "bg-sky-100 text-sky-800", resigned: "bg-slate-200 text-slate-600", terminated: "bg-rose-100 text-rose-700" };
export const STATUS_LABEL = { active: "Active", probation: "Probation", on_leave: "On leave", resigned: "Resigned", terminated: "Terminated" };
